import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const CatalogSelectorDropdownCountsQueryGql: DocumentNode = gql`
query CatalogSelectorDropdownCountsQuery(
  $textSearch: String,
  $hasActiveWarning: Boolean,
  $isCertified: Boolean,
) {
  databaseTablesConnection(
    filter: {
      text: $textSearch,
      hasActiveWarning: $hasActiveWarning,
      isCertified: $isCertified,
    },
    permissionMode: FILTER_RESULTS) {
    totalCount
  }
  databasesConnection(
    filter: {
      text: $textSearch,
      hasActiveWarning: $hasActiveWarning,
      isCertified: $isCertified,
    },
    permissionMode: FILTER_RESULTS) {
    totalCount
  }
}
`;
